<app-header [isAlerts]="true" [hideBackButton]="true"></app-header>
<div class="banner-container">
  <div class="banner-text">
    {{ 'i18n.notifications.emailUnsubscribe.header' | translate }}
  </div>
</div>
<ion-content class="gray-content-bg">
  <div
    class="content"
    *ngIf="tokenUserData$ | async as tokenUserData; else tokenExpired"
  >
    <ng-container *ngIf="userVm$ | async as userVm">
      <ion-card
        *ngIf="userVm.loaded && userVm.isPremierUser"
        class="sorry-card card"
      >
        <ion-card-header class="card-header sorry-card-header">
          {{ 'i18n.notifications.emailUnsubscribe.sorryToSee' | translate }}
        </ion-card-header>
        <ion-card-content class="sorry-card-content">
          <p class="sorry-card-content-text">
            {{ 'i18n.notifications.emailUnsubscribe.belowIsEmailPremier1' |
            translate }}
            <span class="bold-text">
              {{ 'i18n.notifications.emailUnsubscribe.belowIsEmail2' | translate
              }}</span
            >
            {{ 'i18n.notifications.emailUnsubscribe.belowIsEmail3' | translate
            }}
          </p>
          <p>
            {{ 'i18n.common.email' | translate }}: {{ tokenUserData.email }}
          </p>
        </ion-card-content>
      </ion-card>
      <ion-card
        *ngIf="userVm.loaded && userVm.isLoggedIn && !userVm.isPremierUser"
        class="sorry-card card"
      >
        <ion-card-header class="card-header sorry-card-header">
          {{ 'i18n.notifications.emailUnsubscribe.sorryToSee' | translate }}
        </ion-card-header>
        <ion-card-content class="sorry-card-content">
          <p class="sorry-card-content-text">
            {{ 'i18n.notifications.emailUnsubscribe.belowIsEmail1' | translate
            }}
            <span class="bold-text">
              {{ 'i18n.notifications.emailUnsubscribe.belowIsEmail2' | translate
              }}</span
            >
            {{ 'i18n.notifications.emailUnsubscribe.belowIsEmail3' | translate
            }}
          </p>
          <p>
            {{ 'i18n.common.email' | translate }}: {{ tokenUserData.email }}
          </p>
        </ion-card-content>
      </ion-card>
      <ion-card
        *ngIf="userVm.loaded && !userVm.isLoggedIn"
        class="sorry-card card"
      >
        <ion-card-header class="card-header sorry-card-header">
          {{ 'i18n.notifications.emailUnsubscribe.sorryToSee' | translate }}
        </ion-card-header>
        <ion-card-content class="sorry-card-content">
          <p class="sorry-card-content-text">
            {{ 'i18n.notifications.emailUnsubscribe.belowIsEmailGuest1' |
            translate }}
            <span class="bold-text">
              {{ 'i18n.notifications.emailUnsubscribe.belowIsEmailGuest2' |
              translate }}</span
            >
            {{ 'i18n.notifications.emailUnsubscribe.belowIsEmailGuest3' |
            translate }}
          </p>
          <p>
            {{ 'i18n.common.email' | translate }}: {{ tokenUserData.email }}
          </p>
        </ion-card-content>
      </ion-card>
    </ng-container>
    <ion-card class="unsubscribe-card card">
      <ion-card-header class="card-header unsubscribe-card-header">
        {{ 'i18n.notifications.emailUnsubscribe.selectCategories' | translate }}
      </ion-card-header>
      <ion-card-content class="unsubscribe-card-content">
        <ion-list>
          <ion-item lines="full" class="unsubscribe-item">
            <span class="all-alerts-text" slot="end">
              {{ 'i18n.notifications.emailUnsubscribe.allAlerts' | translate }}
            </span>
            <ion-checkbox
              mode="ios"
              slot="end"
              [indeterminate]="selectedCategories.size > 0 && !isAllSelected"
              [checked]="isAllSelected"
              (ionChange)="onUnsubscribeAllChange($event)"
            ></ion-checkbox>
          </ion-item>
          <ion-item class="unsubscribe-item">
            <span class="unsubscribe-item-text"
              >{{ 'i18n.notifications.emailUnsubscribe.paymentsCategory' |
              translate }}</span
            >
            <ion-checkbox
              slot="end"
              mode="ios"
              [checked]="isPaymentSelected"
              (ionChange)="onUnsubscribeChange('PAYMENT', $event)"
            ></ion-checkbox>
          </ion-item>
          <ion-item class="unsubscribe-item">
            <span class="unsubscribe-item-text"
              >{{ 'i18n.notifications.emailUnsubscribe.orderingCategory' |
              translate }}</span
            >
            <ion-checkbox
              slot="end"
              mode="ios"
              [checked]="isOrderSelected"
              (ionChange)="onUnsubscribeChange('ORDER', $event)"
            ></ion-checkbox>
          </ion-item>
          <ion-item class="unsubscribe-item">
            <span class="unsubscribe-item-text"
              >{{ 'i18n.notifications.emailUnsubscribe.deliveryCategory' |
              translate }}</span
            >
            <ion-checkbox
              slot="end"
              mode="ios"
              [checked]="isDeliverySelected"
              (ionChange)="onUnsubscribeChange('DELIVERY', $event)"
            ></ion-checkbox>
          </ion-item>
          <ion-item class="unsubscribe-item">
            <span class="unsubscribe-item-text"
              >{{ 'i18n.notifications.emailUnsubscribe.directShipCategory' |
              translate }}</span
            >
            <ion-checkbox
              slot="end"
              mode="ios"
              [checked]="isDirectSelected"
              (ionChange)="onUnsubscribeChange('DIRECT', $event)"
            ></ion-checkbox>
          </ion-item>
          <ion-item class="unsubscribe-item">
            <span class="unsubscribe-item-text"
              >{{ 'i18n.notifications.emailUnsubscribe.recommendedCategory' |
              translate }}</span
            >
            <ion-checkbox
              slot="end"
              mode="ios"
              [checked]="isTmNoteSelected"
              (ionChange)="onUnsubscribeChange('TM_NOTE', $event)"
            ></ion-checkbox>
          </ion-item>
          <ion-item class="unsubscribe-item">
            <span class="unsubscribe-item-text"
              >{{ 'i18n.notifications.emailUnsubscribe.supportCategory' |
              translate }}</span
            >
            <ion-checkbox
              slot="end"
              mode="ios"
              [checked]="isServiceRequestSelected"
              (ionChange)="onUnsubscribeChange('SERVICE_REQUEST', $event)"
            ></ion-checkbox>
          </ion-item>
        </ion-list>
      </ion-card-content>
      <div class="unsubscribe-card-footer">
        <ion-buttons class="footer-buttons">
          <ion-button
            class="footer-button usf-outline-green-button"
            (click)="onCancel()"
          >
            {{ 'i18n.common.cancel' | translate }}
          </ion-button>
          <ion-button
            class="footer-button"
            [disabled]="!hasSelectedCategories"
            [class.usf-fill-green-button]="hasSelectedCategories"
            [class.usf-fill-disabled-button]="!hasSelectedCategories"
            (click)="onSubmit()"
          >
            {{ 'i18n.common.submit' | translate }}
          </ion-button>
        </ion-buttons>
      </div>
    </ion-card>
  </div>

  <ng-template #tokenExpired>
    <div *ngIf="userVm$ | async as userVm" class="content">
      <ion-card
        *ngIf="userVm.loaded && userVm.isLoggedIn"
        class="card expired-card"
      >
        <ion-card-header class="card-header">
          {{ 'i18n.notifications.emailUnsubscribe.wereSorry' | translate }}
        </ion-card-header>
        <ion-card-content class="expired-card-content">
          <p>
            {{ 'i18n.notifications.emailUnsubscribe.linkExpired' | translate }}
          </p>
          <p>
            <ion-button
              class="manage-alerts-button usf-outline-green-button"
              (click)="routeToManageAlerts()"
              >{{ 'i18n.notifications.emailUnsubscribe.toManageAlerts' |
              translate }}</ion-button
            >
          </p>
        </ion-card-content>
      </ion-card>
      <ion-card
        *ngIf="userVm.loaded && !userVm.isLoggedIn"
        class="card expired-card"
      >
        <ion-card-header class="card-header">
          {{ 'i18n.notifications.emailUnsubscribe.wereSorry' | translate }}
        </ion-card-header>
        <ion-card-content class="expired-card-content">
          <p>
            {{ 'i18n.notifications.emailUnsubscribe.linkExpiredGuest' |
            translate }}
          </p>
          <p>
            <ion-button
              class="manage-alerts-button usf-outline-green-button"
              (click)="routeToLogin()"
              >{{ 'i18n.notifications.emailUnsubscribe.toLogin' | translate
              }}</ion-button
            >
          </p>
        </ion-card-content>
      </ion-card>
    </div>
  </ng-template>
  <app-footer></app-footer>
</ion-content>
